export default __webpack_public_path__ + "static/media/gitam_college_logo.60ec3076.png";